
// ไฟล์: frontend/src/components/layout/Footer.js
import React from 'react';
import './Layout.css';

const Footer = ({ systemInfo }) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-info">
            <div className="footer-logo">
              <img src={systemInfo.logo} alt={systemInfo.name} />
            </div>
            <div className="footer-text">
              <h3>{systemInfo.name}</h3>
              <p>{systemInfo.organization}</p>
              <p>ศูนย์กลางสำหรับครูในการแบ่งปันความรู้ แนวคิด สื่อการสอน และนวัตกรรมทางการศึกษา</p>
            </div>
          </div>
          
          <div className="footer-links">
            <div className="footer-links-column">
              <h4>สำหรับครู</h4>
              <ul>
                <li><a href="/resources">สื่อการสอน</a></li>
                <li><a href="/innovations">นวัตกรรม</a></li>
                <li><a href="/articles">บทความ</a></li>
                <li><a href="/news">ข่าวสาร</a></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h4>สมาชิก</h4>
              <ul>
                <li><a href="/login">เข้าสู่ระบบ</a></li>
                <li><a href="/register">สมัครสมาชิก</a></li>
                <li><a href="/dashboard">แดชบอร์ด</a></li>
                <li><a href="/library">คลังส่วนตัว</a></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h4>ติดต่อเรา</h4>
              <ul className="footer-contact">
                <li>
                  <i className="fas fa-envelope"></i>
                  <a href="mailto:info@teachershare.com">info@teachershare.com</a>
                </li>
                <li>
                  <i className="fas fa-phone"></i>
                  <a href="tel:02-999-9999">02-999-9999</a>
                </li>
                <li>
                  <i className="fas fa-map-marker-alt"></i>
                  <span>กรุงเทพมหานคร ประเทศไทย</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>2025 © <strong>{systemInfo.name}</strong> | ลิขสิทธิ์ถูกต้อง</p>
          </div>
          <div className="footer-developer">
            <p>ผู้พัฒนาโดย : <a href="https://www.kruwirat.com" target="_blank" rel="noopener noreferrer">www.kruwirat.com</a> || tel : 095-602-9737</p>
            <a href="https://www.kruwirat.com" target="_blank" rel="noopener noreferrer">
              <img src="https://www.i-pic.info/i/krVq1004512.jpg" alt="ผู้พัฒนา" className="footer-developer-logo" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
